
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnection4Bars as ObiConnection4BarsElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connection-4-bars.js';
 
 
 

 
 export const ObiConnection4Bars = createComponent({
   react: React,
   tagName: 'obi-connection-4-bars',
   elementClass: ObiConnection4BarsElement,
   events: {
     
   }
  });
 
 